import { render } from "./BaseButton.vue?vue&type=template&id=0213c926&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=0213c926&scoped=true&lang=css"

import exportComponent from "/Users/huangyuhao/Desktop/art-sleuth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0213c926"]])

export default __exports__